import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { verifyEmail } from '../services/auth';
import './VerifyEmail.css';
import BrandLogo from './BrandLogo';

const VerifyEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');

    if (!token) {
      setStatus('error');
      setMessage(
        'Kein Verifizierungstoken gefunden. Bitte verwenden Sie den Link aus Ihrer E-Mail.'
      );
      return;
    }

    const verify = async () => {
      try {
        const response = await verifyEmail(token);
        setStatus('success');
        setMessage(response.message);
      } catch (error: any) {
        setStatus('error');
        // Use the more detailed message if available, otherwise use error
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Fehler bei der E-Mail-Verifizierung';
        setMessage(errorMessage);
      }
    };

    verify();
  }, [searchParams]);

  return (
    <div className="verify-email-container">
      <div className="verify-email-card">
        <div className="card-brand">
          <BrandLogo height={20} withIcon />
        </div>
        <h2>E-Mail-Verifizierung</h2>

        {status === 'loading' && (
          <div className="verify-status">
            <div className="spinner"></div>
            <p>E-Mail wird verifiziert...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="verify-status success">
            <div className="success-icon">✓</div>
            <p className="success-message">{message}</p>
            <button onClick={() => navigate('/login')} className="btn btn-primary">
              Zur Anmeldung
            </button>
          </div>
        )}

        {status === 'error' && (
          <div className="verify-status error">
            <div className="error-icon">✗</div>
            <p className="error-message">{message}</p>
            <div className="verify-actions">
              <Link to="/register" className="btn btn-secondary">
                Neu registrieren
              </Link>
              <Link to="/login" className="btn btn-primary">
                Zur Anmeldung
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
